/* Poufudic - keep the sticky add-to-cart bar's price in step with the buy box.

   The theme renders .productView-stickyCart outside the buy-box scope, so on the
   made-to-order cushion products - which resolve their variant from a metafield
   map rather than from product.variants - the bar kept showing the product's base
   price. On mobile it read $58.70 while the buy box and the cart both said
   $1,302.84. The variant submitted was always correct; only the bar's label was
   stale, which is worse than useless: it understates what the shopper pays.

   This mirrors the buy-box price into the bar. It reads the rendered price rather
   than re-deriving it, so there is a single source of truth.

   The price is read from inside the buy box ONLY. Never trust DOM order here:
   .price-item--regular also matches related-product and recently-viewed cards, and
   picking one of those would reintroduce exactly the wrong-price bug this fixes.
   Scoped: does nothing unless a pf variant map is present on the page. */
(function () {
  'use strict';

  var PRICE_SEL = '.price-item--regular, .price__regular .price-item, [data-pf-price]';
  /* [data-pf-sticky-price] is the read-only price pf-cc-form.js writes into the collapsed bar for
     phones: the theme's own .sticky-price nodes live in .sticky-left (desktop only) and inside the
     hidden mobile panel, so on a phone neither is ever on screen. Same value, same source. */
  var STICKY_SEL = '.productView-stickyCart .sticky-price .money-subtotal, .productView-stickyCart [data-pf-sticky-price]';
  var BUYBOX_SEL = '.productView-product, .productView-options, .product__info-container';
  var CARD_SEL = '.product-item, .card-product, .halo-item, .product-card, product-recommendations, .productView-recently';
  var busy = false;

  function near(el, sel) { return !!(el && el.closest && el.closest(sel)); }

  function buyBoxPrice() {
    var box = document.querySelector(BUYBOX_SEL);
    if (!box) { return null; }
    var nodes = box.querySelectorAll(PRICE_SEL);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = (el.textContent || '').trim();
      if (!t || t.indexOf('$') !== 0) { continue; }
      if (near(el, '.productView-stickyCart') || near(el, CARD_SEL)) { continue; }
      return t;
    }
    return null;
  }

  function sync() {
    if (busy) { return; }
    var p = buyBoxPrice();
    if (!p) { return; }
    busy = true;
    try {
      var targets = document.querySelectorAll(STICKY_SEL);
      for (var i = 0; i < targets.length; i++) {
        if ((targets[i].textContent || '').trim() !== p) { targets[i].textContent = p; }
      }
    } finally {
      busy = false;
    }
  }

  function start() {
    if (!document.querySelector('[data-pf-variant-map]')) { return; }

    sync();
    [150, 400, 900, 1800, 3000, 5000].forEach(function (ms) { setTimeout(sync, ms); });

    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name;
      if (n && n.indexOf('options[') === 0) {
        setTimeout(sync, 0);
        setTimeout(sync, 250);
        setTimeout(sync, 800);
      }
    }, true);

    /* watch the buy box only - never the bar we write to, so there is no feedback loop */
    var host = document.querySelector(BUYBOX_SEL);
    if (host && !host.contains(document.querySelector('.productView-stickyCart'))) {
      try {
        new MutationObserver(function () { sync(); })
          .observe(host, { subtree: true, childList: true, characterData: true });
      } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
